// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"493":"8d6e9fa33816010b","831":"76d85efed7355b8a","979":"5152ca12752a07c2"}[chunkId] + ".js";
};